var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon40BlogRisk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 2 10 20H2L12 2m0-2a2 2 0 0 0-1.79 1.1l-10 20A2 2 0 0 0 2 24h20a2 2 0 0 0 1.79-2.9l-10-20A2 2 0 0 0 12 0z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.16 10.36a6.3 6.3 0 0 1-10.48 0h0",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+DQogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgPHBhdGggZD0ibTEyIDIgMTAgMjBIMkwxMiAybTAtMmEyIDIgMCAwIDAtMS43OSAxLjFsLTEwIDIwQTIgMiAwIDAgMCAyIDI0aDIwYTIgMiAwIDAgMCAxLjc5LTIuOWwtMTAtMjBBMiAyIDAgMCAwIDEyIDB6IiBmaWxsPSIjMDAwIiAvPg0KICAgIDxwYXRoIGQ9Ik0xNy4xNiAxMC4zNmE2LjMgNi4zIDAgMCAxLTEwLjQ4IDBoMCIgc3Ryb2tlPSIjMDAwIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPg0KICA8L2c+DQo8L3N2Zz4NCg==";
export { SvgIcon40BlogRisk as ReactComponent };